export enum ResourceType {
  DEVICE = 'DEVICE',
  LOCATION = 'LOCATION',
  SENSOR = 'SENSOR',
  USER = 'USER',
}
